import en from "./en";
import sk from "./sk";

export const messages = {
  en,
  sk,
};
